import { render, staticRenderFns } from "./GraphDetail48.vue?vue&type=template&id=1d9d24b8&scoped=true&"
import script from "./GraphDetail48.vue?vue&type=script&lang=js&"
export * from "./GraphDetail48.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d24b8",
  null
  
)

export default component.exports